import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { createQueryParams } from '../helpers';
import { TimelineEventsPage, TimelineEventsQuery } from '../interfaces/timeline.interface';

/** One timeline of every entity type (cards, contacts, companies, tasks, chats) of the current company */
@Injectable({ providedIn: 'root' })
export class TimelineService {
  private readonly http = inject(HttpClient);

  /** E.g. `{ entity_type: CHAT, entity_id }` for one chat or `{ created_by }` for everything a user did */
  public getEvents(query: TimelineEventsQuery = {}): Observable<TimelineEventsPage> {
    const { event_type, ...rest } = query;
    const params = createQueryParams({ ...rest, event_type: event_type?.length ? event_type.join(',') : undefined });
    return this.http
      .get<any>(environment.baseURL + '/timeline', { params })
      .pipe(map((res) => res.data));
  }
}
